import { useState } from "react";
import { Link } from "react-router-dom";
import { usePortal } from "../../../context/PortalContext";
import authAPI from "../../../services/authApi";
import AuthShell from "../Auth/AuthShell";
import AuthField from "../Auth/AuthField";
import Button from "../../ui/Button";
import AuthButtonLink from "../Auth/AuthButtonLink";
import a from "../Auth/auth.module.css";

export default function PatientForgotPassword() {
  const { subdomain, clinic } = usePortal();
  const clubName = clinic?.name || null;
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devUrl, setDevUrl] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await authAPI.forgotPassword(email.trim(), subdomain);
      if (r.result === 0) {
        setSent(true);
        if (r.devResetUrl) setDevUrl(r.devResetUrl);
      } else {
        setErr(r.message || r.error || "Ошибка");
      }
    } catch (e) {
      setErr(e.response?.data?.error || "Ошибка запроса");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      modern
      backTo="/login"
      backLabel="К входу"
      showSwitcher={false}
      cardTitle={sent ? "Проверьте почту" : "Сброс пароля"}
      hint={
        sent
          ? "Если аккаунт с таким email есть, мы отправили ссылку для сброса пароля."
          : "Укажите email — пришлём ссылку для создания нового пароля."
      }
      clubTag={clubName}
      stepCurrent={sent ? 2 : 1}
      stepTotal={2}
      stepLabels={["Email", "Готово"]}
    >
      {sent ? (
        <>
          {devUrl ? (
            <p className={a.infoBox}>
              Dev: <a href={devUrl}>ссылка</a>
            </p>
          ) : null}
          <div className={a.actions}>
            <AuthButtonLink to="/login">К входу</AuthButtonLink>
          </div>
        </>
      ) : (
        <form onSubmit={submit}>
          {err ? <div className={a.errorBox}>{err}</div> : null}
          <AuthField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={loading}>
              {loading ? "Отправка…" : "Отправить"}
            </Button>
          </div>
          <div className={a.footerLinks}>
            <Link to="/login">
              Вспомнили пароль? <span>Войти</span>
            </Link>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
